import { Card, Typography } from '@bharatpe/bharat-ui';
import React from 'react';
import RupeeIcon from 'assets/icons/Autopay/rupee.svg';
import { formatDateDynamic } from 'utils/Utils';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const TicketDetails: React.FC<any> = ({ complaintDetails }) => {
	const { languageData } = useLanguageConfig();

	return (
		<>
			<div className="mx5 mt6">
				<Card className="p4 mb5 mt5 flex flex-column">
					<div className="flex flex-row flex-center flex-justify">
						<div className="flex flex-column">
							<Typography variant="Light100" className="text-left ">
								{languageData.TRANSACTION_AMOUNT}
							</Typography>
							<Typography variant="Bold500 mt2" className="text-left">
								{`₹${complaintDetails.amount}`}
							</Typography>
						</div>
						<div className="flex flex-end ml2 p3 br4 secondary-background">
							<img src={RupeeIcon} width={36} height={36} />
						</div>
					</div>
					<div className="horizontal-divider my4" />
					<div className="flex flex-column flex-start">
						<Typography variant="Light100" className="grey-dark">
							{languageData.PAID_TO_2}
						</Typography>
						<Typography variant="Regular100" className="mt2">
							{complaintDetails.payee_name}
						</Typography>
						<Typography variant="Light100" className="grey-dark mt1">
							{formatDateDynamic(complaintDetails.registered_date, `DD MMM, YYYY | h:mm a`)}
						</Typography>
					</div>
					<div className="horizontal-divider my4" />
					<div className="flex flex-column flex-start">
						<Typography variant="Light100" className="grey-dark">
							{languageData.COMPLAINT_RAISED}
						</Typography>
						<Typography variant="Regular100" className="mt2">
							{complaintDetails?.remarks}
						</Typography>
						<Typography variant="Light100" className="grey-dark mt1">
							{formatDateDynamic(complaintDetails.updated_at, `DD MMM, YYYY | h:mm a`)}
						</Typography>
					</div>
				</Card>
			</div>
		</>
	);
};
export default TicketDetails;
